import React, { useContext } from 'react';
import Controls from './components/controls/controls';
import Products from './components/products/productsContainer';
import ErrorBoundary from './components/errorBoundary/errorBoundary';
import { ListerContext } from './listerContext';
import listerAppStyles from './listerApp.module.pcss';
import FadeOverlay from './components/overlays/fadeOverlay';
import Backdrop from './components/overlays/backdrop';
import FacetsMenu from './components/facetsMenu/facetsMenu';
import PaginatedResults from './components/pagination/paginatedResults';
import useAttraqtTrackerViewEvent from './hooks/useAttraqtTrackerViewEvent';
import useSimpleBodyScrollLock from './hooks/useSimpleBodyScrollLock';
import useFixFacetsMenu from './hooks/useFixFacetsMenu';

function ListerApp(): React.ReactElement {
  const [{ isFacetsDisplayed, isListerDisabled }] = useContext(ListerContext);
  const { facetsRef, facetsMenuRef, listingRef } = useFixFacetsMenu();
  useAttraqtTrackerViewEvent();
  useSimpleBodyScrollLock(isFacetsDisplayed);

  return (
    <div className={listerAppStyles.lister}>
      <ErrorBoundary>
        <Controls />
        <div className={listerAppStyles['lister__wrapper']}>
          <Backdrop active={isFacetsDisplayed} />
          <aside
            className={`${listerAppStyles['lister__facets']} ${
              isFacetsDisplayed ? listerAppStyles['lister__facets--fixed-width'] : ''
            }`}
            ref={facetsRef}
          >
            <div className={listerAppStyles['lister__facets-menu']} ref={facetsMenuRef}>
              <FacetsMenu isFacetsDisplayed={isFacetsDisplayed} />
            </div>
          </aside>
          <main className={listerAppStyles['lister__listing']} ref={listingRef}>
            <PaginatedResults>
              <Products />
            </PaginatedResults>
          </main>
        </div>
        <FadeOverlay active={isListerDisabled} />
      </ErrorBoundary>
    </div>
  );
}

export default ListerApp;
